import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertFilledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 10 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5.5,
		r: 5,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.95247 6.74C4.82447 6.74 4.71514 6.69733 4.62447 6.612C4.5338 6.52133 4.4858 6.412 4.48047 6.284L4.36047 3.116C4.35514 2.99333 4.39514 2.88667 4.48047 2.796C4.5658 2.70533 4.6698 2.66 4.79247 2.66H5.22447C5.34714 2.66 5.45114 2.70533 5.53647 2.796C5.6218 2.88667 5.6618 2.99333 5.65647 3.116L5.53647 6.284C5.53114 6.412 5.48314 6.52133 5.39247 6.612C5.3018 6.69733 5.19247 6.74 5.06447 6.74H4.95247ZM5.14447 7.38C5.26714 7.38 5.37114 7.42533 5.45647 7.516C5.54714 7.60667 5.59247 7.71333 5.59247 7.836V8.044C5.59247 8.16667 5.54714 8.27333 5.45647 8.364C5.37114 8.45467 5.26714 8.5 5.14447 8.5H4.87247C4.7498 8.5 4.64314 8.45467 4.55247 8.364C4.46714 8.27333 4.42447 8.16667 4.42447 8.044V7.836C4.42447 7.71333 4.46714 7.60667 4.55247 7.516C4.64314 7.42533 4.7498 7.38 4.87247 7.38H5.14447Z",
		fill: "white"
	})]
});
export default SvgAlertFilledIcon;
